import {
  Alert,
  Chip,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from '@mui/material';
import { useAIActions } from '../api/queries/aiActions';

export function DebugAiActionsRoute() {
  const { data, isLoading, isError, error } = useAIActions();

  return (
    <Paper className="p-6" data-testid="debug-ai-actions">
      <Typography variant="h4" gutterBottom>
        AI actions
      </Typography>

      {isLoading && <Typography>Loading…</Typography>}
      {isError && (
        <Alert severity="error">
          Failed to load: {(error as Error).message}
        </Alert>
      )}

      {data && (
        <>
          <Typography variant="caption" color="text.secondary">
            {data.length} registered actions
          </Typography>
          <List>
            {data.map((a) => (
              <ListItem key={a.id} data-testid="ai-action-item">
                <ListItemText
                  primary={
                    <span className="flex items-center gap-2">
                      <span>{a.name}</span>
                      {a.category && <Chip label={a.category} size="small" />}
                    </span>
                  }
                  secondary={a.description ?? a.slug}
                />
              </ListItem>
            ))}
          </List>
        </>
      )}
    </Paper>
  );
}
